import { takeEvery } from 'redux-saga/effects';

import { updateRange } from 'store/modules/listing/customPrices';

import * as customPrices from './utils';

export default function* listenUpdateRange() {
  yield takeEvery(updateRange.toString(), customPrices.updateRange);
}
